import { render, staticRenderFns } from "./PublicRouter.vue?vue&type=template&id=81ee5572&scoped=true&"
import script from "./PublicRouter.vue?vue&type=script&lang=js&"
export * from "./PublicRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ee5572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81ee5572')) {
      api.createRecord('81ee5572', component.options)
    } else {
      api.reload('81ee5572', component.options)
    }
    module.hot.accept("./PublicRouter.vue?vue&type=template&id=81ee5572&scoped=true&", function () {
      api.rerender('81ee5572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/public/PublicRouter.vue"
export default component.exports